export default __webpack_public_path__ + "static/media/header_hiring.4ab984e1.png";